import {useState,useEffect} from 'react';
import { isDarkThemeEnabled } from '../../stores/sessionStore';

const ColorSchemeToggle=()=>{
    const [isDarkMode,setIsDarkMode]=useState(false);

    const toggleColorScheme=()=>{
        const newMode = !isDarkMode;
        localStorage.setItem("theme", newMode ? "dark" : "light");  // Persist theme in localStorage
        localStorage.setItem("flowbite-theme-mode", newMode ? "dark" : "light");  // Persist theme in localStorage for flowbite react theme toggle

        // Update the atom store with the new value
        isDarkThemeEnabled.set(newMode);

        // Update local state
        setIsDarkMode(newMode);

        if(typeof refreshTafsirFrame==="function")
        {
            refreshTafsirFrame();
        }

        // Apply the dark mode class to the document
        document.documentElement.classList.toggle('dark', newMode);
    }

    useEffect(()=>{
        if (localStorage.theme === 'dark' || (!('theme' in localStorage))) 
        {
            setIsDarkMode(true);
            isDarkThemeEnabled.set(true);
            document.documentElement.classList.add('dark');
        } 
        else 
        {
            setIsDarkMode(false);
            isDarkThemeEnabled.set(false);
            document.documentElement.classList.remove('dark');
        }
        
        const scriptColorScheme=localStorage.getItem("theme");
        const reactColorScheme=localStorage.getItem("flowbite-theme-mode");
        
        if(scriptColorScheme===null)
        {
            localStorage.setItem("theme","dark");
        }
        
        if(reactColorScheme===null)
        {
            localStorage.setItem("flowbite-theme-mode","dark");
        }

        const unsubscribe = isDarkThemeEnabled.subscribe(value => {
            setIsDarkMode(value);  // Update local state when store changes
            document.documentElement.classList.toggle('dark', value);  // Ensure DOM reflects the theme
        });
      
        // Cleanup subscription on component unmount
        return unsubscribe;
    },[]);

    return(
        <label id="color-scheme-switch" htmlFor="color-scheme-toggle" className="mx-auto md:m-0" onClick={toggleColorScheme}>
            <span id="circle" className={`block${isDarkMode?` toggled`:``}`}></span>
            <img id="text2" src="/images/light.svg" alt="light-color-scheme-icon" width={"24"} height={"24"}/>
            <img id="text" src="/images/dark.svg" alt="dark-color-scheme-icon" width={"24"} height={"24"}/>
        </label>
    )
}

export default ColorSchemeToggle;